module.exports = "assets/1ba66a9bdb18c3b7a4e0da5119af3673.gif";